import { Component, forwardRef } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  UntypedFormBuilder,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { EqTest, NoneTest } from '@app/library/models/filters.model';

@Component({
  selector: 'rk-filter-playlist-input',
  templateUrl: './filter-playlist-input.component.html',
  styleUrls: ['./filter-playlist-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterPlaylistInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FilterPlaylistInputComponent),
      multi: true,
    },
  ],
})
export class FilterPlaylistInputComponent implements ControlValueAccessor, Validator {
  playlistForm: UntypedFormGroup;

  constructor(private readonly fb: UntypedFormBuilder) {
    this.playlistForm = this.fb.group({
      no: false,
      yes: false,
    });
  }

  onTouched: () => void = () => {};

  writeValue(val: any): void {
    if (!val) {
      return;
    }
    this.playlistForm.setValue(this.fromFilterToFormValue(val), { emitEvent: false });
  }

  fromFilterToFormValue(val: EqTest | NoneTest): { no: boolean; yes: boolean } {
    if (val.operator === 'none') {
      return {
        no: false,
        yes: false,
      };
    } else if (val.operator === 'equals') {
      if (val.value === '0') {
        return {
          no: true,
          yes: false,
        };
      }

      return {
        yes: true,
        no: false,
      };
    }

    throw new RangeError(`Unhandled operator "${val.operator}"`);
  }

  fromFormValueToFilter(val: any): EqTest | NoneTest {
    const { yes, no } = val;
    if ((yes && no) || (!yes && !no)) {
      return {
        operator: 'none',
      };
    }
    if (yes) {
      return {
        operator: 'equals',
        value: '1',
      };
    }

    return {
      operator: 'equals',
      value: '0',
    };
  }

  registerOnChange(fn: any): void {
    this.playlistForm.valueChanges.subscribe(val => fn(this.fromFormValueToFilter(val)));
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.playlistForm.disable() : this.playlistForm.enable();
  }

  validate(_: AbstractControl): ValidationErrors | null {
    return this.playlistForm.valid
      ? null
      : { invalidForm: { valid: false, message: 'TAGS' } };
  }
}
